<template>
  <div>
    <div class="row flex">
      <div class="col-md-12 mt-2">
        <label>Resend confirmation email</label>
      </div>
      <div class="col-md-8">
        <form
          class="form-inline"
        >
          <input
            v-model="customerEmail"
            :class="{ 'is-invalid': $v.customerEmailCache.$invalid}"
            type="email"
            :disabled="userCanResendConfirmation === false"
            class="form-control full-width"
            placeholder="Enter email address..."
          >
        </form>
      </div>
      <div class="col-md-4">
        <button
          :disabled="$v.customerEmailCache.$invalid || userCanResendConfirmation === false"
          type="button"
          class="btn btn-primary float-right full-width"
          @click="sendConfirmationEmail"
        >
          Send
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BookingService from '../../../api/booking-service.js'
import { required, email } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'ConfirmationEmail',
    props: ['editMode'],
    data () {
        return {
            customerEmailCache: ''
        }
    },
    computed: {
        ...mapState({
            bookingDetail: state => state.booking.bookingDetail
        }),
        ...mapGetters({
            userCanResendConfirmation: 'auth/userCanResendConfirmation'
        }),
        customerEmail: {
            get: function () {
                return this.customerEmailCache
            },
            set: function (val) {
                this.customerEmailCache = val.toString().toLowerCase()
            }
        },
        canEdit () {
            if (this.bookingDetail != null) {
                return this.bookingDetail.channelTypeID !== 8
            }
            return false
        }
    },
    mounted () {
        this.$store.watch(
            (state) => {
                return state.booking.getCustomerDetailsLoading
            }, (val) => {
                if (val === false) this.customerEmailCache = this.$store.state.booking.customer.email
            },
            { immediate: true }
        )
    },
    validations: {
        customerEmailCache: {
            required,
            email
        }
    },
    methods: {
        async sendConfirmationEmail () {
            await BookingService.sendConfirmationEmail(this.$store.state.booking.bookingDetail.id, this.customerEmailCache)
            this.$store.dispatch('getAudit', this.$route.params.bookingId)
            this.$toasted.success('Confirmation email has been sent to the customer')
        }
    }
}
</script>

<style lang="scss" scoped>
.full-width {
    width: 100%;
}
</style>
